import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import Video from '../../../models/video';

const RATIO = 16/9;

class VideoView extends Component {
  static propTypes = {
    video: PropTypes.instanceOf(Video).isRequired
  };

  constructor() {
    super();

    this.calculateSize = this.calculateSize.bind(this);
    this.state = {
      containerWidth: 520,
      containerHeight: 520 / RATIO
    };
  }

  componentDidMount() {
    this.calculateSize();
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.calculateSize);
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.calculateSize)
    }
  }

  calculateSize() {
    const container = findDOMNode(this.refs.containers).parentNode;
    const containerRect = container.getBoundingClientRect();

    this.setState({
      containerWidth: containerRect.width,
      containerHeight: containerRect.width / RATIO
    });
  }

  render() {
    const { video } = this.props;
    const { containerWidth, containerHeight } = this.state;

    const containerStyle = {
      width: containerWidth,
      height: containerHeight
    };

    // XXX: 아래 'https://vfarm.tv.kakao.com' 는 sandbox, production 환경 나눌 때 설정해줘야 함.
    const playPath = (video.get('playUrl').includes('sandbox') ? 'https://sandbox-tv.kakao.com' : 'https://tv.kakao.com') + '/embed/player';
    const videoSrc = `${playPath}/${(!video.get('clipLinkId') || video.get('clipLinkId') === 0) ? 'livelink/'.concat(video.get('liveLinkId'))
      : 'cliplink/'.concat(video.get('clipLinkId'))}?service=kakao_talkplus&play_loc=kakao_talkplus&autoplay=true`;

    return (
      <div className="card_default card_vod">
        <a href="#" className="link_card" ref="containers" style={{ height: 'auto' }}>
          <div id="videoPlayer" className="wrap_thumb" style={containerStyle}>
            <iframe
              title={video.name}
              width="100%" height={360 * RATIO}
              style={containerStyle}
              src={videoSrc}
              frameBorder="0"
              scrolling="no"
              allowFullScreen
            />
          </div>
        </a>
      </div>
    );
  }
}

export default VideoView;



// WEBPACK FOOTER //
// ./src/components/PostBox/media/VideoView.js